<template>
  <div class="connector-template">connector-template</div>
</template>
<script>
export default {
  name: "connector-template",
  props: {},
  data() {
    return {};
  },
  methods: {},
  components: {},
};
</script>
<style scoped lang=""></style>